<app-menu-superior [user]="user" [button]="true" [title]="'SUBASTA'"></app-menu-superior>

<ion-content [fullscreen]="true">
  <ion-grid class="grid-class">

    <!-- HEADER PANEL SUBASTA -->
    <ion-row style="height: auto;">
      <ion-col size=12 class="headers ion-no-padding">
        <ion-row>
          <ion-col size="8" class="vertical" style="padding:1px 1px 1px 0px">
            <div class="datoCab verticalLeft">
              <div class="verticalLeft">
                <fa-icon class="fontVh25" [icon]="faService.faShip"></fa-icon>
              </div>
              <div style="flex:10" class="verticalLeft">
                <ion-label class="verticalLeft font-small">
                  &nbsp;{{subasta.proveedor}}
                </ion-label>
              </div>
            </div>
          </ion-col>
          <ion-col class="vertical" style="padding:1px 0px 1px 0px">
            <div class="datoCab verticalRight">
              <div style="flex:0.2">
                <fa-icon style="font-size: 14px;" [icon]="faService.faIndustry"></fa-icon>
              </div>
              <div style="flex:2">
                <ion-label class="verticalLeft font-small">
                  &nbsp;{{puerto}}
                </ion-label>
              </div>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col style="padding: 0;" size="8">
            <ion-row class="vertical" style="height: 50%;">
              <ion-col class="vertical" style="padding:0px 1px 1px 0px">
                <div class="datoCab verticalLeft">
                  <div class="verticalLeft">
                    <fa-icon class="fontVh25" [icon]="faService.faFish"></fa-icon>
                  </div>
                  <div style="flex:10" class="verticalLeft">
                    <ion-label class="verticalLeft font-small">
                      &nbsp;{{subasta.especie}} &nbsp;{{tpf}}
                    </ion-label>
                  </div>
                </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col style="padding-left: 0;" style="padding:0px 1px 0px 0px">
                <div class="datoCab verticalRight">
                  <div style="flex:0.25">
                    <fa-icon class="fontVh25" [icon]="faService.faWeightHanging"></fa-icon>
                  </div>
                  <div style="flex:2">
                    <ion-label class="verticalRight font-small" style="font-size: 18px;">
                      {{ cantidad | number:'1.2-2':'es'}} {{unidad}}&nbsp;
                    </ion-label>
                  </div>
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
          <ion-col class="vertical ion-no-padding" style=" text-align: center;background-color: white;" size="4">
            <img [src]="imagenEspecie" onError="this.src='/assets/img/image_not_found.jpg'"
              *ngIf="setImagenes.length == 0" class="img-style" />
            <swiper-container #swiper [slidesPerView]="1" [centeredSlides]="true" [autoplay]="true" [spaceBetween]="20"
              [ngClass]="setImagenes.length == 0 ? 'no-display' : '' ">
              <swiper-slide *ngFor="let imagen of setImagenes; let i = index" style="width: 100px">
                <img [src]="imagen.foto" onError="this.src='/assets/img/image_not_found.jpg'" class="img-style" />
              </swiper-slide>
            </swiper-container>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" class="vertical" style="padding:1px 0px 1px 0px">
            <div class="datoCab verticalLeft">
              <div class="verticalLeft">
                <fa-icon class="fontVh25" [icon]="faService.faComment"></fa-icon>
              </div>
              <swiper-container #swiperObs [slidesPerView]="1" [centeredSlides]="true" [autoplay]="true"
                [spaceBetween]="20">
                <swiper-slide *ngFor="let obs of setImagenes; let i = index">
                  <p style="font-size: 14px" class="pobs textElipsis">&nbsp; {{obs.observaciones}} </p>
                </swiper-slide>
              </swiper-container>
            </div>
          </ion-col>
        </ion-row><ion-row class="headers bg-dark vertical">
          <ion-col size="5" class="vertical ion-no-padding">

            <ion-input style="padding-top: 1px;" label="" *ngIf="!paradaPrevia.id" class="input-paradaprevia"
              maxlength="7" #ionicInput [disabled]="paradaPrevia.id || !subasta.especie" inputmode="decimal"
              onPaste="return false;" onDrag="return false;" onDrop="return false;"
              (keydown)="numberOnlyValidation($event)" (ionInput)="onChange($event)" (ionFocus)="updateFocus($event)"
              (ionBlur)="updateBlur($event)" value="{{paradaPrevia.precio_formateado}}"
              placeholder="Precio €/{{unidad}}" (keyup.enter)="$event.target.blur(); createParadaPrevia()"
              [ngClass]="!showParadaPrevia && paradaPrevia.precio_formateado ? 'password-class' : '' "></ion-input>

            <ion-label class="fakeInputPrecioParada" *ngIf="paradaPrevia.id ">
              <span *ngIf="showParadaPrevia == true">
                {{paradaPrevia.precio | number:'1.2-2':'es'}} €/{{unidad ? unidad : 'KG'}}
              </span>
              <span *ngIf="showParadaPrevia == false">
                ****
              </span>
            </ion-label>


          </ion-col>
          <ion-col size="5" class="vertical ion-no-padding" *ngIf="storageService.isWeb == true"
            style="padding-top: 1px;">
            <ion-button (click)="createParadaPrevia()" class="btn-save-parada" *ngIf="!paradaPrevia.id"
              [disabled]="!subasta.especie">
              AÑADIR PARADA
            </ion-button>
            <ion-button (click)="deleteParadaPrevia()" class="btn-save-parada" *ngIf="paradaPrevia.id"
              [disabled]="!subasta.especie">
              BORRAR PARADA
            </ion-button>
          </ion-col>
          <ion-col size="5" class="vertical ion-no-padding" *ngIf="storageService.isWeb == false"
            style="padding-top: 1px;">
            <ion-button (touchstart)="createParadaPrevia()" class="btn-save-parada" *ngIf="!paradaPrevia.id"
              [disabled]="!subasta.especie">
              AÑADIR PARADA
            </ion-button>
            <ion-button (touchstart)="deleteParadaPrevia()" class="btn-save-parada" *ngIf="paradaPrevia.id"
              [disabled]="!subasta.especie">
              BORRAR PARADA
            </ion-button>
          </ion-col>
          <ion-col size="2" class="vertical ion-no-padding">
            <ion-button tabindex="-1" (mousedown)="pressDownToggle();" (mouseup)="pressUpToggle()"
              (touchstart)="pressDownToggle($event)" (touchend)="pressUpToggle($event)" (blur)="blurEye()"
              class="button-eye" [disabled]="!subasta.especie">
              <fa-icon class="icons" [icon]="faService.faEye" style="  font-size: 14px;padding: 11px;"
                class="no-margin"></fa-icon>
            </ion-button>
          </ion-col>
        </ion-row>

      </ion-col>
    </ion-row>

    <!-- PARADA PREVIA FORMULARIO -->

    <ion-row *ngIf="winnerName" class="winner-row">
      <ion-col size="12" class="vertical">Usuario ganador: {{winnerName}}</ion-col>
    </ion-row>

    <!-- PRECIO BAJADA Y BOTON -->
    <ion-row style="height: auto; background-color: aliceblue; ">
      <ion-col class="ion-no-padding">
        <ion-row>
          <ion-col size="12" class="ion-no-padding vertical">
            <ion-item class="priceCol" style="width: 100%;" lines="none">
              <ion-label position="stacked" class="label-precio-texto">
                PRECIO
              </ion-label>
              <ion-input label="" class="in-precio ion-text-end" [ngClass]="allowMediaCss ? 'in-precio-small' : ''"
                [value]="precioFormatted" readonly="true" inputmode="decimal" size="6"></ion-input>
              <ion-label class="label-precio-unidad">€/{{unidad ? unidad : 'KG'}}</ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" class="vertical ion-text-center col-button ion-no-padding"
          [ngClass]="{'pujar':canBid == true,'pujar-deshabilitado': canBid == false, 'pujar-winner' : winner == true}" *ngIf="storageService.isWeb == true">
            <ion-button
              [ngClass]="{'btn-pujar':canBid == true,'btn-pujar-deshabilitado': canBid == false, 'btn-pujar-winner' : winner == true}"
              (click)="sendMSG()">
              <ion-label class="ion-text-cemter">{{textoBotonParada}}</ion-label>
            </ion-button>
          </ion-col>
          <ion-col size="12" [ngClass]="{'pujar':canBid == true,'pujar-deshabilitado': canBid == false, 'pujar-winner' : winner == true}"class="vertical ion-text-center col-button ion-no-padding"
           *ngIf="storageService.isWeb == false">
            <ion-button
              [ngClass]="{'btn-pujar':canBid == true,'btn-pujar-deshabilitado': canBid == false, 'btn-pujar-winner' : winner == true}"
              (touchstart)="sendMSG()">
              <ion-label class="ion-text-cemter">{{textoBotonParada}}</ion-label>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>

    <!-- HEADER ADJS -->
    <ion-row class="headers sticky-top font-header" style="background-color: #3b3f51;">
      <ion-col size="0.5" class="vertical">
      </ion-col>
      <ion-col size="3" class="vertical" style="padding-right:0;padding-left: 0;">
        <ion-label style="font-size: smaller;">ESPECIE</ion-label>
      </ion-col>
      <ion-col size="3" class="vertical " style="padding-right:0;padding-left: 0;">

        <ion-label style="font-size: small;">CANT.<span style="font-size: 8px; text-align:right">KG</span></ion-label>

      </ion-col>
      <ion-col size="2.5" class="vertical " style="padding-right:0;padding-left: 0;">

        <ion-label style="font-size: small;">PRECIO <span style="font-size: 8px; text-align:right">€</span></ion-label>

      </ion-col>
      <ion-col size="3" class="vertical " style="padding-right:0;padding-left: 0;">

        <ion-label style="font-size: small;">IMP. <span style="font-size: 8px; text-align:right">€/KG</span></ion-label>

      </ion-col>
    </ion-row>
    
    <!-- LISTA ADJS -->
    <ion-row style="flex-grow: 1; overflow-y: scroll;background-color: #7194a5;">
      <ion-col class="ion-no-padding">
        <ion-row *ngFor="let compra of compras; let odd = odd; let i = index;" class="compra-row font-small">
          <ion-col size="0.5" class="vertical">
            <ion-label>{{compras.length - i}}</ion-label>
          </ion-col>
          <ion-col size="3" class="verticalLeft" style="padding-left:15px">
            <ion-label class="compra-especie-label">{{compra.especie}} </ion-label>
          </ion-col>
          <ion-col size="3" class="vertical">
            <ion-label>
              {{compra.cantidad | number:'1.2-2':'es'}}
            </ion-label>
          </ion-col>
          <ion-col size="2.5" class="vertical">
            <ion-label>
              {{compra.precio | number:'1.2-2':'es'}}
            </ion-label>
          </ion-col>
          <ion-col size="3" class="vertical">
            <ion-label>
              {{compra.importe | number:'1.2-2':'es'}}
            </ion-label>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>

    <!-- FOOTER ADJS -->
    <ion-row>
      <ion-col class="headers verticalRight footer" size="">
        {{totalCantidad | number:'1.2-2':'es' }} {{unidad ? unidad : 'KG'}}
      </ion-col>
      <ion-col size="5.5" class="headers ion-text-right verticalRight footer" style="color:white">
        {{totalImporte | number:'1.2-2':'es'}}&nbsp;€&nbsp;&nbsp;</ion-col>
    </ion-row>

  </ion-grid>
</ion-content>